import { fetchAdminBillingAccountRelations } from './fetchAdminBillingAccountRelations';
import type { QueryFunctionContext } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import type { billingKeys } from './billingKeys';
import type { TAdminBillingAccountDetails } from './types/TAdminBillingAccountDetails';

type TParams = QueryFunctionContext<ReturnType<typeof billingKeys.adminAccount>>;

export const createFetchAdminBillingAccountQueryFn =
  (call: TCall) =>
  async ({ queryKey: [{ baId }], signal }: TParams): Promise<TAdminBillingAccountDetails> => {
    const [account, billingConfiguration, relations] = await Promise.all([
      call(() => cancelOnSignal(AdminService.getBillingAccount({ baId }), signal)),
      call(() => cancelOnSignal(AdminService.getAdminBillingAccountConfiguration({ baId }), signal)),
      fetchAdminBillingAccountRelations(call, baId, signal),
    ]);
    return { ...account, billingConfiguration, ...relations };
  };
